import React from 'react'
import Loading from 'custom/assets/loaders/Loading'

function NeoLoader({ width = '50px', height = '50px', text='' }) {
  return (
    <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
      <Loading width={width} height={height} />{text}
    </div>
  )
}

export default NeoLoader
